import React from "react";
import { LinkProps } from "@jasperlabs/jux-next";

import { useActiveTenant } from "tenants/TenantProvider";
import SanityUrlOrFileLink from "./SanityUrlOrFileLink";

export function TenantPrivacyPolicyLink({
	children = "Privacy Policy",
	...props
}: Omit<LinkProps<"a">, "href" | "children"> & { children?: React.ReactNode }) {
	const tenant = useActiveTenant();

	return (
		<SanityUrlOrFileLink
			urlOrFile={
				tenant.privacyPolicy ?? { type: "url", url: null, fileUrl: null }
			}
			{...props}
		>
			{children}
		</SanityUrlOrFileLink>
	);
}
